"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var button_1 = tslib_1.__importDefault(require("../button"));
var NormalClose_1 = require("../Icons/NormalClose");
var AnqTag = function (props) {
    var _a = tslib_1.__read((0, react_1.useState)(true), 2), visible = _a[0], setVisible = _a[1];
    var _b = props.size, size = _b === void 0 ? 'default' : _b, _c = props.type, type = _c === void 0 ? 'primary' : _c, text = props.text, className = props.className, icon = props.icon, closable = props.closable, disabled = props.disabled, onClick = props.onClick, onClose = props.onClose, textMaxWidth = props.textMaxWidth, style = props.style, _d = props.blank, blank = _d === void 0 ? false : _d, _e = props.underline, underline = _e === void 0 ? false : _e;
    var handleClose = (0, react_1.useCallback)(function () {
        onClose && onClose();
        setVisible(false);
    }, [onClose]);
    var handleClick = (0, react_1.useCallback)(function () {
        if (onClick) {
            onClick();
        }
    }, [onClick]);
    if (!visible) {
        return null;
    }
    if (closable) {
        return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)('anq-tags', 'anq-tags-closable', className, {
                'anq-tags-disabled': !!disabled,
                'anq-tags-small': size === 'small',
                'anq-tags-blank': blank,
                'anq-tags-underline': underline,
            }), title: props.title },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('anq-tags-text', {
                    'anq-tag-text-ellipsis': textMaxWidth !== undefined,
                }), style: { maxWidth: textMaxWidth } }, text),
            !disabled && react_1.default.createElement(NormalClose_1.NormalClose, { className: "anq-tags-close-icon", onClick: handleClose })));
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('anq-tags', className, "anq-tags-".concat(props.color || type), {
            'anq-tags-small': size === 'small',
            'anq-tags-blank': blank,
            'anq-tags-underline': underline,
        }), onClick: handleClick, style: style, title: props.title },
        icon && react_1.default.createElement("span", { className: "anq-tags-icon" }, icon),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('anq-tags-text', {
                'anq-tag-text-ellipsis': textMaxWidth !== undefined,
            }), style: { maxWidth: textMaxWidth } }, text)));
};
var TagFilter = function (props) {
    var dataSource = props.dataSource, value = props.value, onChange = props.onChange, label = props.label, className = props.className, _a = props.mode, mode = _a === void 0 ? 'multiple' : _a;
    var selectedItem = Array.isArray(value) ? value : [value];
    var handleClick = (0, react_1.useCallback)(function (val, checked) {
        if (mode === 'single') {
            onChange(val, checked);
            return;
        }
        var arr;
        if (checked) {
            arr = tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(selectedItem), false), [val], false);
        }
        else {
            arr = selectedItem.filter(function (i) { return i !== val; });
        }
        onChange(val, checked, arr);
    }, [value, onChange]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('anq-tag-filter', className) },
        label ? react_1.default.createElement("span", { className: 'anq-tag-filter-label' }, label) : null,
        dataSource.map(function (item) {
            var checked = selectedItem.includes(item.value);
            if (checked) {
                return (react_1.default.createElement(AnqTag, { key: item.value, onClick: function () { return handleClick(item.value, false); }, text: item.label, className: mode === 'multiple' ? 'anq-tag-filter-checked' : 'anq-tag-filter-single-checked' }));
            }
            return (react_1.default.createElement(button_1.default, { onClick: function () { return handleClick(item.value, true); }, size: "small", disabled: item.disabled, className: "anq-tag-btn", type: checked ? 'primary' : 'text', key: item.value }, item.label));
        })));
};
AnqTag.TagFilter = TagFilter;
exports.default = AnqTag;
//# sourceMappingURL=index.js.map